import React from "react";
import { render } from "react-dom";

import "./styles/reset.css";
import "./styles/style.css";
import "./styles/react-select.css";
import "react-datetime/css/react-datetime.css";
import "./styles/fonts/font-awesome.css";
import "./styles/react-grid-layout.css";

import { createStore, applyMiddleware, combineReducers } from "redux";
import { BrowserRouter, Route, Switch, Redirect } from "react-router-dom";
import { Provider } from "react-redux";
import thunk from "redux-thunk";
import logger from "redux-logger";
import { enableBatching } from "redux-batched-actions";

import { AuthHOC } from "./components/AuthHOC";
// import ConstructionView from "./components/Construction";
import NotfoundView from "./components/Notfound";

import { rootReducer } from "./reducers";

import Login from "./components/Login";
import { FormBrowser } from "./components/FormBrowser";
// import { Report } from "./components/Report";
import { Dashboard } from "./components/Dashboard";

const reducer = combineReducers({
  orm: rootReducer
});
let middleware = [thunk]; //, logger];
const store = createStore(
  enableBatching(reducer),
  applyMiddleware(...middleware)
);

render(
  <BrowserRouter>
    <Provider store={store}>
      <div>
        <Switch>
          <Route
            exact
            path="/"
            render={() => <Redirect to="/dashboard/main" />}
          />
          <Route path="/login" component={AuthHOC(Login)} />
          <Route
            exact
            path="/dashboard"
            render={() => <Redirect to="/dashboard/main" />}
          />
          <Route path="/dashboard/:name" component={AuthHOC(Dashboard)} />
          <Route
            exact
            path="/settings"
            render={() => <Redirect to="/settings/reports" />}
          />
          <Route path="/settings/:name" component={AuthHOC(FormBrowser)} />
          <Route component={AuthHOC(NotfoundView)} />
        </Switch>
      </div>
    </Provider>
  </BrowserRouter>,
  document.getElementById("root")
);

// <Route exact path="/settings/reports" component={AuthHOC(Report)} />



// WEBPACK FOOTER //
// ./src/index.js